import { Helmet } from "react-helmet-async"
import { useLocation } from "react-router-dom"

import { mediaStyle } from "components/ui/media"
import { IS_PORTAL, jewlr_t } from "helpers/application"
import {
  getHreflangs,
  getMetaDescription,
  getMetaIcons,
  getMetaKeywords,
} from "helpers/meta"

const MetaTags = () => {
  const location = useLocation()
  const hreflangs = getHreflangs(location.pathname)
  const metaIcons = getMetaIcons()

  return (
    <Helmet
      defaultTitle={`${jewlr_t("terms.Personalized")} ${jewlr_t(
        "terms.Jewelry"
      )} | Custom Gemstones & Engravings`}
      encodeSpecialCharacters={false}
      prioritizeSeoTags
      titleTemplate={`%s | ${IS_PORTAL() ? "Customize Your Jewelry" : "Jewlr"}`}
    >
      <meta content="max-image-preview:large" name="robots" />
      {IS_PORTAL() && <meta content="noindex, nofollow" name="robots" />}
      <meta content={getMetaDescription()} name="description" />
      <meta content={getMetaDescription()} property="og:description" />
      <meta content={getMetaKeywords()} name="keywords" />
      <meta content="website" property="og:type" />
      <meta content={sl.config.site_title} property="og:site_name" />
      <meta
        content={`https://${sl.config.site_url}`}
        id="org_url"
        property="og:url"
      />
      <meta
        content={`${sl.config.jewlr_asset_url}favicons/${metaIcons.ogImage}`}
        name="og_image"
        property="og:image"
      />
      {/* new favicons from realfavicongenerator.net */}
      <link
        href={`${sl.config.jewlr_asset_url}favicons/${metaIcons.png}`}
        rel="icon"
        sizes="96x96"
        type="image/png"
      />
      <link
        href={`${sl.config.jewlr_asset_url}favicons/${metaIcons.svg}`}
        rel="icon"
        type="image/svg+xml"
      />
      <link
        href={`${sl.config.jewlr_asset_url}favicons/${metaIcons.favicon}`}
        rel="shortcut icon"
      />
      <link
        href={`${sl.config.jewlr_asset_url}favicons/${metaIcons.appleIcon}`}
        rel="apple-touch-icon"
        sizes="180x180"
      />
      <link
        href={`https://${sl.config.site_url}/site.webmanifest`}
        rel="manifest"
      />
      <link
        href={`https://${sl.config.site_url}${location.pathname}`}
        rel="canonical"
      />
      {hreflangs.map(({ href, hreflang }) => (
        <link href={href} hrefLang={hreflang} key={hreflang} rel="alternate" />
      ))}
      <style type="text/css">{mediaStyle}</style>
    </Helmet>
  )
}

export default MetaTags
